var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('w-btn',{attrs:{"color":_vm.error ? 'red' : 'blue',"loading":_vm.loading,"disabled":_vm.disabled,"text":_vm.$t('common.next'),"icon":_vm.error ? 'mdi-alert' : 'mdi-page-next'},on:{"press":_vm.press}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }